import React from 'react';
import { Gift, CheckCircle, AlertTriangle } from 'lucide-react';
export function BonusSection() {
  return <section className="bg-white py-10 md:py-14 px-4" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-6 font-['Oswald'] uppercase text-center" data-id="element-21">
          📦 ¿Qué incluye?
        </h2>

        {/* Main items */}
        <div className="space-y-2 max-w-md mx-auto mb-8" data-id="element-22">
          {['Guía educativa completa del cuerpo humano', 'Material visual atractivo y fácil de entender', 'Actividades didácticas listas para usar'].map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-blue-50 p-3 rounded-lg" data-id="element-23">
              <Gift className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-24" />
              <span className="text-sm font-semibold text-gray-800" data-id="element-25">
                {item}
              </span>
            </div>)}
        </div>

        {/* Bonuses */}
        <div className="text-center mb-4" data-id="element-26">
          <p className="text-lg font-black text-gray-900" data-id="element-27">
            Además, HOY recibes <span className="text-red-600" data-id="element-28">GRATIS:</span>
          </p>
        </div>

        <div className="space-y-3 mb-6" data-id="element-29">
          {[{
          icon: '🎯',
          title: 'Bono 1: Kit Premium de Evaluaciones',
          desc: 'Para reforzar lo aprendido',
          image: 'https://cdn.magicpatterns.com/uploads/aSCyHz4WsMQZBfDwCeS1b3/bono1_sin_fondo.png'
        }, {
          icon: '🎲',
          title: 'Bono 2: MegaPack de Juegos Didácticos',
          desc: 'Aprender jugando (lo que más funciona)',
          image: 'https://cdn.magicpatterns.com/uploads/gXd34HjrCJ5QfopDrvLCzH/bono2_sin_fondo.png'
        }, {
          icon: '📅',
          title: 'Bono 3: Planificador Estratégico de Ciencias',
          desc: 'Organización fácil para padres',
          image: 'https://cdn.magicpatterns.com/uploads/8nevuoysUqhsGMPRifE3WW/bono3_sin_fondo.png'
        }].map((bonus, idx) => <div key={idx} className="bg-white rounded-xl shadow-md p-4 flex items-center gap-4 border border-gray-200" data-id="element-30">
              <img src={bonus.image} alt={bonus.title} className="w-20 h-20 object-contain flex-shrink-0" data-id="element-31" />
              <div data-id="element-32">
                <div className="inline-block bg-green-100 text-green-700 text-[10px] font-bold px-2 py-0.5 rounded mb-1" data-id="element-33">
                  GRATIS
                </div>
                <h4 className="text-sm font-bold text-gray-900" data-id="element-34">
                  {bonus.icon} {bonus.title}
                </h4>
                <p className="text-xs text-gray-600" data-id="element-35">👉 {bonus.desc}</p>
              </div>
            </div>)}
        </div>

        {/* Urgency */}
        <div className="bg-red-50 border-2 border-red-300 rounded-xl p-4 text-center" data-id="element-36">
          <p className="text-sm font-bold text-red-700 flex items-center justify-center gap-2" data-id="element-37">
            <AlertTriangle className="w-4 h-4" data-id="element-38" />
            🚨 IMPORTANTE: Estos bonos no estarán disponibles para siempre.
          </p>
          <p className="text-xs text-red-600 mt-1" data-id="element-39">
            👉 Solo están incluidos por tiempo limitado.
          </p>
        </div>
      </div>
    </section>;
}